module.exports = __webpack_public_path__ + "fonts/813b3d2.otf";